var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_vm._m(0),_c('h2',[_vm._v(_vm._s(_vm.message)),_c('br')])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-404"},[_c('h2',[_vm._v("ไม่พบข้อมูลของท่าน")])])
}]

export { render, staticRenderFns }